import {
  INVENTORY_LOCATION_REQUESTING,
  LIST_INVENTORY_LOCATIONS_SUCCESS,
  RESET_INVENTORY_LOCATION_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_INVENTORY_LOCATION_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case INVENTORY_LOCATION_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_INVENTORY_LOCATIONS_SUCCESS: {
      const data = { ...state.data };
      action.payload.forEach((object) => {
        data[object.id] = object;
      });
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
